import { useState } from "react";
import { useNavigate } from "react-router-dom";

export interface SettingsSection {
  id: string;
  title: string;
  icon: React.ComponentType<{ className?: string }>;
  description: string;
  category: string;
  priority: string;
}

export interface SettingsCategory {
  title: string;
  description: string;
}

export const useSettingsNavigation = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(new Set(["core"]));

  const selectSection = (sectionId: string) => {
    navigate(`/settings/${sectionId}`);
    setIsMobileMenuOpen(false);
  };

  const toggleCategory = (category: string) => {
    const newExpanded = new Set(expandedCategories);
    if (newExpanded.has(category)) {
      newExpanded.delete(category);
    } else {
      newExpanded.add(category);
    }
    setExpandedCategories(newExpanded);
  };

  const openMobileMenu = () => {
    setIsMobileMenuOpen(true);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return {
    searchQuery,
    setSearchQuery,
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    expandedCategories,
    selectSection,
    toggleCategory,
    openMobileMenu,
    closeMobileMenu,
  };
};
